package com.essntl.features.service.ui.addextraservice

import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface AddExtraServiceEvent {
    // Extra service
    data class UpdateExtraServiceFields(val extraService: ExtraServiceModel) : AddExtraServiceEvent
    data object AddExtraService : AddExtraServiceEvent

    // Service
    data object LoadExtraCategoryServices : AddExtraServiceEvent
    data class EditFilterOptions(val filterOptions: ServiceFilterOptions) : AddExtraServiceEvent
    data class UpdateService(val service: ServiceModel) : AddExtraServiceEvent
    data class AddService(val title: String) : AddExtraServiceEvent
}